'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import ReactUtilsPropTypes from 'react-utils/CustomPropTypes';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as globalWidgetsSelectors from 'DesignData/selectors/globalWidgets';
import * as GlobalWidgetsActions from 'DesignData/actions/GlobalWidgets';
import Toolbar from 'DesignEditorsUI/components/globalWidgetEditor/Toolbar';
/*
 * Connect
 */

function makeMapStateToProps() {
  const getPastEditHistoryCount = globalWidgetsSelectors.makeGetPastEditHistoryCount();
  const getFutureEditHistoryCount = globalWidgetsSelectors.makeGetFutureEditHistoryCount();
  return function mapStateToProps(state, props) {
    const globalWidget = globalWidgetsSelectors.getGlobalWidget(state, props);
    return {
      isPublishDisabled: !globalWidget,
      pastEditHistoryCount: getPastEditHistoryCount(state, props),
      futureEditHistoryCount: getFutureEditHistoryCount(state, props)
    };
  };
}

const mapDispatchToProps = {
  publishGlobalWidget: GlobalWidgetsActions.publish,
  undoGlobalWidgetEdit: GlobalWidgetsActions.undoEdit,
  redoGlobalWidgetEdit: GlobalWidgetsActions.redoEdit
};
/**
 *
 * @class
 */

class ToolbarContainer extends Component {
  constructor(...args) {
    super(...args);

    this.undoGlobalWidgetEdit = () => {
      if (!this.props.pastEditHistoryCount) {
        return;
      }

      this.props.undoGlobalWidgetEdit(this.props.globalWidgetId);
    };

    this.redoGlobalWidgetEdit = () => {
      if (!this.props.futureEditHistoryCount) {
        return;
      }

      this.props.redoGlobalWidgetEdit(this.props.globalWidgetId);
    };

    this.publishGlobalWidget = () => {
      this.props.publishGlobalWidget(this.props.globalWidgetId);
    };
  }

  /*
   * Render
   */
  render() {
    return /*#__PURE__*/_jsx(Toolbar, {
      pastEditHistoryCount: this.props.pastEditHistoryCount,
      futureEditHistoryCount: this.props.futureEditHistoryCount,
      undoGlobalWidgetEdit: this.undoGlobalWidgetEdit,
      redoGlobalWidgetEdit: this.redoGlobalWidgetEdit,
      publishGlobalWidget: this.publishGlobalWidget,
      isPublishDisabled: this.props.isPublishDisabled
    });
  }

}

ToolbarContainer.propTypes = {
  globalWidgetId: PropTypes.number.isRequired,
  // connect()
  isPublishDisabled: PropTypes.bool.isRequired,
  publishGlobalWidget: PropTypes.func.isRequired,
  // Undo/Redo
  pastEditHistoryCount: ReactUtilsPropTypes.uint32.isRequired,
  futureEditHistoryCount: ReactUtilsPropTypes.uint32.isRequired,
  undoGlobalWidgetEdit: PropTypes.func.isRequired,
  redoGlobalWidgetEdit: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(ToolbarContainer);